var _style, _path, _path2, _path3, _rect, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreditCardIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 367.3",
    style: {
      enableBackground: "new 0 0 512 367.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#EDF0F2;}\n\t.st1{fill:#DAE1E6;}\n\t.st2{fill:#3ABBE6;}\n\t.st3{fill:#33A6CC;}\n\t.st4{fill:#C9D2D9;}\n\t.st5{fill:#E6563A;}\n\t.st6{fill:#FFCC33;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M461.9,0H50.1C22.5,0,0,22.5,0,50.1v50.1h512V50.1C512,22.5,489.5,0,461.9,0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M461.9,0H256v100.2h256V50.1C512,22.5,489.5,0,461.9,0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M0,66.8V167h512V66.8H0z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 256,
    y: 66.8,
    className: "st3",
    width: 256,
    height: 100.2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,133.6v183.7c0,27.6,22.5,50.1,50.1,50.1h411.8c27.6,0,50.1-22.5,50.1-50.1V133.6H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M256,367.3h205.9c27.6,0,50.1-22.5,50.1-50.1V133.6H256V367.3z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M217,300.5H83.5c-9.2,0-16.7-7.5-16.7-16.7V217c0-9.2,7.5-16.7,16.7-16.7H217c9.2,0,16.7,7.5,16.7,16.7v66.8 C233.7,293,226.3,300.5,217,300.5z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M345.1,300.5c-13.2,0-26-5.1-35.5-14.6c-13.4-13.4-18-33.1-12.1-51.5c4.8-14.9,16.5-26.6,31.4-31.4 c18.3-5.9,38.1-1.3,51.5,12.1s18,33.1,12.1,51.5c-4.8,14.9-16.5,26.6-31.4,31.4C355.9,299.7,350.5,300.5,345.1,300.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M395.2,300.5c-13.2,0-26-5.1-35.5-14.6c-13.4-13.4-18-33.1-12.1-51.5c4.8-14.9,16.5-26.6,31.4-31.4 c18.3-5.9,38.1-1.3,51.5,12.1c13.4,13.4,18,33.1,12.1,51.5c-4.8,14.9-16.5,26.6-31.4,31.4C406,299.7,400.6,300.5,395.2,300.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCardIcon);
export default __webpack_public_path__ + "static/media/credit_card_icon.30de69e8ac5835392f33e3da6c8a3e0c.svg";
export { ForwardRef as ReactComponent };